import { useEditorRef } from '@udecode/plate-common';

/**
 * Takes an `element` (which it only needs for its `id`) and returns the
 * Upload object from it.
 */
export const useUpload = (id) => {
  const editor = useEditorRef();

  /**
   * We call this even if it's not always required because it calls `useStore`
   * which is a React hook which means it needs to be called consistently.
   */
  const upload = editor.cloud.uploadStore.use.upload(id) || {
    status: 'not-found',
  };

  return upload;
};